import type { ResolvedComponent } from "@inertiajs/react";

/** Laravel `Inertia::render()` names map to `.tsx` modules under `./Pages/`. */
const inertiaPageModules = import.meta.glob<{ default: ResolvedComponent }>([
  "./Pages/**/*.tsx",
  "!./Pages/**/*.test.tsx",
]);

/** Resolves a page name to the `./Pages/` relative path key used by `import.meta.glob`. */
const toPageGlobKey = (name: string): string => {
  const cleaned = name.trim().replaceAll("\\", "/").replace(/^\/+/u, "");

  return `./Pages/${cleaned}.tsx`;
};

export const resolveInertiaPage = async (name: string): Promise<ResolvedComponent> => {
  const key = toPageGlobKey(name);
  const loadPage = inertiaPageModules[key];

  if (loadPage === undefined) {
    throw new Error(`Page not found: ${name} (${key})`);
  }

  const moduleExports = await loadPage();

  return moduleExports.default;
};
